import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 44;

export const migration_43_44:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface )
        {
            designState.surface.scrollbarProp = getScrollbarPropSnapshotValue();
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function getScrollbarPropSnapshotValue()
{
    return {
        'id': 'da55d0b3-f8ea-4ddc-89c8-9349f533e80c',
        'name': 'scrollbar',
        'group': 'baseProperty',
        'bindingIds': [],
        '_value': {
            'isEnabled': {
                '__type': 'BOOLEAN',
                'value': false
            },
            'width': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 12
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'trackBackground': {
                'type': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'Solid Color',
                    'values': [
                        'Solid Color',
                        'Linear Gradient'
                    ]
                },
                'solidColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#fff'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 0.12
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientFromColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#fff'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 1
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientToColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 1
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientAngle': {
                    '__type': 'NUMBER',
                    'value': 0
                }
            },
            'trackBorder': {
                'borderColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 1
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': false
                    }
                },
                'borderThickness': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 1
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'borderStyle': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'solid',
                    'values': [
                        'solid',
                        'dashed',
                        'dotted'
                    ]
                },
                'borderRadius': {
                    'topLeft': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 0
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'topRight': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 0
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'bottomLeft': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 0
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'bottomRight': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 0
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    }
                },
                'borderFill': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'borderAll',
                    'values': [
                        'borderLeft',
                        'borderTop',
                        'borderRight',
                        'borderBottom',
                        'borderAll'
                    ]
                }
            },
            'trackShadow': {
                'color': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 0.2
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': false
                    }
                },
                'deltaX': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'deltaY': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'blur': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'spread': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'thumbBackground': {
                'type': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'Solid Color',
                    'values': [
                        'Solid Color',
                        'Linear Gradient'
                    ]
                },
                'solidColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 0.24
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientFromColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#fff'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 1
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientToColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 1
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'gradientAngle': {
                    '__type': 'NUMBER',
                    'value': 0
                }
            },
            'thumbBorder': {
                'borderColor': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 0
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': true
                    }
                },
                'borderThickness': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 3
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'borderStyle': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'solid',
                    'values': [
                        'solid',
                        'dashed',
                        'dotted'
                    ]
                },
                'borderRadius': {
                    'topLeft': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 6
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'topRight': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 6
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'bottomLeft': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 6
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    },
                    'bottomRight': {
                        'value': {
                            '__type': 'NUMBER',
                            'value': 6
                        },
                        'unitsType': {
                            '__type': 'STRINGENUM',
                            'selectedValue': 'px',
                            'values': [
                                'px',
                                '%',
                                'auto'
                            ]
                        }
                    }
                },
                'borderFill': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'borderAll',
                    'values': [
                        'borderLeft',
                        'borderTop',
                        'borderRight',
                        'borderBottom',
                        'borderAll'
                    ]
                }
            },
            'thumbShadow': {
                'color': {
                    'color': {
                        'hex': {
                            '__type': 'STRING',
                            'value': '#000'
                        },
                        'alpha': {
                            '__type': 'NUMBER',
                            'value': 0.2
                        }
                    },
                    'visibility': {
                        '__type': 'BOOLEAN',
                        'value': false
                    }
                },
                'deltaX': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'deltaY': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'blur': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 4
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'spread': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            }
        }
    };
}
